import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "grey fw600 fs13",
  style: {"margin-bottom":"16px"}
}
const _hoisted_2 = {
  key: 1,
  style: {"width":"360px"}
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_5 = {
  key: 2,
  class: "whiteColor fs8"
}
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { class: "posRe" }
const _hoisted_8 = {
  key: 0,
  class: "posAb rad10 with_white_bg",
  style: {"right":"30px","bottom":"-10px","width":"60px","height":"25px","padding":"1px 7px","border":"2px solid #eee"}
}
const _hoisted_9 = ["for"]
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChipButton = _resolveComponent("ChipButton")!
  const _component_SearchCalendarsContent = _resolveComponent("SearchCalendarsContent")!
  const _component_CheckboxTag = _resolveComponent("CheckboxTag")!
  const _component_UserIcon = _resolveComponent("UserIcon")!
  const _component_AttendeesGroupFieldMenu = _resolveComponent("AttendeesGroupFieldMenu")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("section", null, [
    (_ctx.magindex > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, "または"))
      : _createCommentVNode("", true),
    (_ctx.cm.edittingAttendees && _ctx.magindex == _ctx.editIndex && _ctx.purposeType != `instant_room`)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (false && _ctx.rcm.createType == `vote`)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cm.edittingAttendees, (ctag, ctagindex) => {
                    return (_openBlock(), _createElementBlock("li", {
                      style: {"height":"48px"},
                      key: ctagindex
                    }, [
                      _createElementVNode("span", null, _toDisplayString(ctag.name), 1)
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cm.edittingAttendees, (ctag, ctagindex) => {
            return (_openBlock(), _createBlock(_component_ChipButton, {
              key: `${ctagindex}${ctag.systemUpdatedAt}${_ctx.editIndex}${ctag.email}${_ctx.mag.systemUpdatedAt}`,
              name: `${ctag.name}`,
              returnVal: ctag,
              imageUrl: ctag.owner ? ctag.owner.image_url : null,
              onSelect: ($event: any) => (_ctx.clickSelectCtag(ctag)),
              onDelete: ($event: any) => (_ctx.deleteSelectCtag(ctag)),
              style: `margin-bottom:4px;`
            }, null, 8, ["name", "returnVal", "imageUrl", "onSelect", "onDelete"]))
          }), 128)),
          _hoisted_4,
          (_ctx.cm.edittingAttendees && _ctx.cm.edittingAttendees.length > 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "pointer centered fs13 blueAround circle_button rad8 fl fw600",
                style: {"padding":"6px 15px"},
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.fixedAttendeesInGroup && _ctx.fixedAttendeesInGroup(...args)))
              }, " この出席者で決定 "))
            : _createCommentVNode("", true),
          _createVNode(_component_SearchCalendarsContent, { autoLoadWeeklyCalendar: _ctx.autoLoadWeeklyCalendar }, null, 8, ["autoLoadWeeklyCalendar"]),
          (_ctx.isDev)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.searchedCtags ? _ctx.searchedCtags.length : 0), 1))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", {
              class: "lskyblueBg rad8 pointer fs12 fw600 hoverLgreyBg w95",
              style: {"padding":"32px 21px","margin-top":"10px"},
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.editGroup && _ctx.editGroup(...args)))
            }, _toDisplayString(_ctx.attendeesName), 1),
            _createElementVNode("div", {
              class: "circleBlueButton pointer selected posAb",
              style: {"top":"-10px","left":"10px","font-size":"17px"},
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.editGroup && _ctx.editGroup(...args)))
            }, _toDisplayString(_ctx.mag.name), 1),
            (_ctx.cm.mags && _ctx.cm.mags.length > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_CheckboxTag, {
                    value: ``,
                    name: `display_calendar_name_${_ctx.mag.name}`,
                    checked: _ctx.mag.name == _ctx.cm.displayMagName,
                    prefix: `display_calendar_name_${_ctx.mag.name}`,
                    onClickCheckbox: _ctx.clickChangeDisplayMag,
                    style: {"transform":"scale(1)","cursor":"pointer"},
                    class: "ml1 noBorder fl checkedDefaultColor",
                    disabled: _ctx.mag.name == _ctx.cm.displayMagName
                  }, null, 8, ["name", "checked", "prefix", "onClickCheckbox", "disabled"]),
                  _createElementVNode("label", {
                    for: `display_calendar_name_${_ctx.mag.name}_`,
                    class: "fs12 pointer fw600 fl mt3 ml4"
                  }, "表示", 8, _hoisted_9)
                ]))
              : _createCommentVNode("", true),
            (_ctx.hasProfile)
              ? _withDirectives((_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "circleBlueButton pointer posAb ofh",
                  style: {"top":"-10px","left":"50px","border-radius":"50%"},
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.editProfile(_ctx.mag)))
                }, [
                  (_ctx.mag.profile_image_urls && _ctx.mag.profile_image_urls[0])
                    ? (_openBlock(), _createBlock(_component_UserIcon, {
                        key: 0,
                        imageUrl: _ctx.mag.profile_image_urls[0],
                        canEdit: false,
                        updateSelf: false,
                        width: 30,
                        style: {"margin-left":"-1px"}
                      }, null, 8, ["imageUrl"]))
                    : (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: _ctx.$getAssetImageUrl(`/assets/icons/usertype_grey.png`),
                        width: "30",
                        height: "30"
                      }, null, 8, _hoisted_10))
                ])), [
                  [
                    _directive_tooltip,
                    `公開プロフィール設定済み`,
                    void 0,
                    { top: true }
                  ]
                ])
              : _createCommentVNode("", true),
            (_ctx.noWraitable)
              ? _withDirectives((_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: "pointer posAb",
                  style: {"top":"-5px","left":"100px"},
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.editProfile(_ctx.mag)))
                }, [
                  _createElementVNode("img", {
                    src: _ctx.$getAssetImageUrl(`/assets/icons/status_ng.png`),
                    width: "20",
                    height: "20"
                  }, null, 8, _hoisted_11)
                ])), [
                  [
                    _directive_tooltip,
                    `日程確定時にカレンダーに書込みできない状態です`,
                    void 0,
                    { top: true }
                  ]
                ])
              : _createCommentVNode("", true),
            _createVNode(_component_AttendeesGroupFieldMenu, {
              mag: _ctx.mag,
              magindex: _ctx.magindex,
              purposeType: _ctx.purposeType,
              onDeleteGroup: _ctx.deleteGroup,
              onAddProfile: _ctx.addProfile,
              onAddZoom: _ctx.addZoom
            }, null, 8, ["mag", "magindex", "purposeType", "onDeleteGroup", "onAddProfile", "onAddZoom"])
          ]),
          _hoisted_12,
          _hoisted_13,
          (
                    _ctx.cm.astag.meeting_attendees_groups.length - 1 == _ctx.magindex && _ctx.editIndex == -1 && _ctx.purposeType != `instant_room`
                )
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "pointer centered fs13 blueAround circle_button rad8 fl fw600",
                style: {"padding":"6px 15px"},
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.addNextGroupField && _ctx.addNextGroupField(...args)))
              }, " 「または」を追加 "))
            : _createCommentVNode("", true)
        ]))
  ]))
}